export const languages = [
    { label: "Afrikaans ", value: "af" },
    { label: "Albanian ", value: "sq" },
    { label: "Arabic ", value: "ar" },
    { label: "Azerbaijani ", value: "az" },
    { label: "Bengali ", value: "bn" },
    { label: "Bulgarian ", value: "bg" },
    { label: "Catalan ", value: "ca" },
    { label: "Chinese (China)", value: "zh_CN" },
    { label: "Chinese (HongKong)", value: "zh_HK" },
    { label: "Chinese (Taiwan) ", value: "zh_TW" },
    { label: "Croatian ", value: "hr" },
    { label: "Czech ", value: "cs" },
    { label: "Danish ", value: "da" },
    { label: "Dutch ", value: "nl" },
    { label: "English", value: "en","lang_enable":"Y","locale":"en-GB"},
    { label: "English UK", value: "en_GB" },
    { label: "English ", value: "en_US" },
    { label: "Estonian ", value: "et" },
    { label: "Filipino ", value: "fil" },
    { label: "Finnish ", value: "fi" },
    { label: "French ", value: "fr","lang_enable":"Y","locale":"fr-BE"},
    { label: "German ", value: "de" },
    { label: "Greek ", value: "el" },
    { label: "Gujarati ", value: "gu" },
    { label: "Hausa ", value: "ha" },
    { label: "Hebrew ", value: "he" },
    { label: "Hindi ", value: "hi" },
    { label: "Hungarian ", value: "hu" },
    { label: "Indonesian ", value: "id" },
    { label: "Irish ", value: "ga" },
    { label: "Italian ", value: "it" },
    { label: "Japanese ", value: "ja" },
    { label: "Kannada ", value: "kn" },
    { label: "Kazakh ", value: "kk" },
    { label: "Korean ", value: "ko" },
    { label: "Lao ", value: "lo" },
    { label: "Latvian ", value: "lv" },
    { label: "Lithuanian ", value: "lt" },
    { label: "Macedonian ", value: "mk" },
    { label: "Malay ", value: "ms" },
    { label: "Malayalam ", value: "ml" },
    { label: "Marathi ", value: "mr" },
    { label: "Norwegian ", value: "nb" },
    { label: "Persian ", value: "fa" },
    { label: "Polish ", value: "pl" },
    { label: "Portuguese (BR)", value: "pt_BR" },
    { label: "Portuguese (POR)", value: "pt_PT" },
    { label: "Punjabi ", value: "pa" },
    { label: "Romanian ", value: "ro" },
    { label: "Russian ", value: "ru" },
    { label: "Serbian ", value: "sr" },
    { label: "Slovak ", value: "sk" },
    { label: "Slovenian ", value: "sl" },
    { label: "Spanish ", value: "es" },
    { label: "Spanish (ARG)", value: "es_AR" },
    { label: "Spanish (SPA)", value: "es_ES" },
    { label: "Spanish (MEX)", value: "es_MX" },
    { label: "Swahili ", value: "sw" },
    { label: "Swedish ", value: "sv" },
    { label: "Tamil ", value: "ta" },
    { label: "Telugu ", value: "te" },
    { label: "Thai ", value: "th" },
    { label: "Turkish ", value: "tr" },
    { label: "Ukrainian ", value: "uk" },
    { label: "Urdu ", value: "ur" },
    { label: "Uzbek ", value: "uz" },
    { label: "Vietnamese ", value: "vi" },
    { label: "Zulu ", value: "zu" },
    { label: "Kreol ", value: "cr" }

]

export const timeZones = {
    'Europe/Andorra' : "ad",
    'Asia/Dubai' : "ae",
    'Asia/Kabul' : "af",
    'Europe/Tirane' : "al",
    'Asia/Yerevan' : "am",
    'Antarctica/Casey' : "aq",
    'Antarctica/Davis' : "aq",
    'Antarctica/DumontDUrville' : "aq",
    'Antarctica/Mawson' : "aq",
    'Antarctica/Palmer' : "aq",
    'Antarctica/Rothera' : "aq",
    'Antarctica/Syowa' : "aq",
    'Antarctica/Troll' : "aq",
    'Antarctica/Vostok' : "aq",
    'America/Argentina/Buenos_Aires' : "ar",
    'America/Argentina/Cordoba' : "ar",
    'America/Argentina/Salta' : "ar",
    'America/Argentina/Jujuy' : "ar",
    'America/Argentina/Tucuman' : "ar",
    'America/Argentina/Catamarca' : "ar",
    'America/Argentina/La_Rioja' : "ar",
    'America/Argentina/San_Juan' : "ar",
    'America/Argentina/Mendoza' : "ar",
    'America/Argentina/San_Luis' : "ar",
    'America/Argentina/Rio_Gallegos' : "ar",
    'America/Argentina/Ushuaia' : "ar",
    'Pacific/Pago_Pago' : "as",
    'Europe/Vienna' : "at",
    'Australia/Lord_Howe' : "au",
    'Antarctica/Macquarie' : "au",
    'Australia/Hobart' : "au",
    'Australia/Currie' : "au",
    'Australia/Melbourne' : "au",
    'Australia/Sydney' : "au",
    'Australia/Broken_Hill' : "au",
    'Australia/Brisbane' : "au",
    'Australia/Lindeman' : "au",
    'Australia/Adelaide' : "au",
    'Australia/Darwin' : "au",
    'Australia/Perth' : "au",
    'Australia/Eucla' : "au",
    'Asia/Baku' : "az",
    'America/Barbados' : "bb",
    'Asia/Dhaka' : "bd",
    'Europe/Brussels' : "be",
    'Europe/Sofia' : "bg",
    'Atlantic/Bermuda' : "bm",
    'Asia/Brunei' : "bn",
    'America/La_Paz' : "bq",
    'America/Noronha' : "br",
    'America/Belem' : "br",
    'America/Fortaleza' : "br",
    'America/Recife' : "br",
    'America/Araguaina' : "br",
    'America/Maceio' : "br",
    'America/Bahia' : "br",
    'America/Sao_Paulo' : "bt",
    'America/Campo_Grande' : "br",
    'America/Cuiaba' : "br",
    'America/Santarem' : "br",
    'America/Porto_Velho' : "br",
    'America/Boa_Vista' : "br",
    'America/Manaus' : "br",
    'America/Eirunepe' : "br",
    'America/Rio_Branco' : "br",
    'America/Nassau' : "bs",
    'Asia/Thimphu' : "bt",
    'Europe/Minsk' : "by",
    'America/Belize' : "bz",
    'America/St_Johns' : "ca",
    'America/Halifax' : "ca",
    'America/Glace_Bay' : "ca",
    'America/Moncton' : "ca",
    'America/Goose_Bay' : "ca",
    'America/Blanc-Sablon' : "ca",
    'America/Toronto' : "ca",
    'America/Nipigon' : "ca",
    'America/Thunder_Bay' : "ca",
    'America/Iqaluit' : "ca",
    'America/Pangnirtung' : "ca",
    'America/Atikokan' : "ca",
    'America/Winnipeg' : "ca",
    'America/Rainy_River' : "ca",
    'America/Resolute' : "ca",
    'America/Rankin_Inlet' : "ca",
    'America/Regina' : "ca",
    'America/Swift_Current' : "ca",
    'America/Edmonton' : "ca",
    'America/Cambridge_Bay' : "ca",
    'America/Yellowknife' : "ca",
    'America/Inuvik' : "ca",
    'America/Creston' : "ca",
    'America/Dawson_Creek' : "ca",
    'America/Fort_Nelson' : "ca",
    'America/Vancouver' : "ca",
    'America/Whitehorse' : "ca",
    'America/Dawson' : "ca",
    'Indian/Cocos' : "cc",
    'Europe/Zurich' : "ch",
    'Africa/Abidjan' : "ci",
    'Pacific/Rarotonga' : "ck",
    'America/Santiago' : "cl",
    'America/Punta_Arenas' : "cl",
    'Pacific/Easter' : "cl",
    'Asia/Shanghai' : "cn",
    'Asia/Urumqi' : "cn",
    'America/Bogota' : "co",
    'America/Costa_Rica' : "cr",
    'America/Havana' : "cu",
    'Atlantic/Cape_Verde' : "cv",
    'America/Curacao' : "cw",
    'Indian/Christmas' : "cx",
    'Asia/Nicosia' : "cy",
    'Asia/Famagusta' : "cy",
    'Europe/Prague' : "cz",
    'Europe/Berlin' : "de",
    'Europe/Copenhagen' : "dk",
    'America/Santo_Domingo' : "do",
    'Africa/Algiers' : "dz",
    'America/Guayaquil' : "ec",
    'Pacific/Galapagos' : "ec",
    'Europe/Tallinn' : "ee",
    'Africa/Cairo' : "eg",
    'Africa/El_Aaiun' : "ma",
    'Europe/Madrid' : "es",
    'Africa/Ceuta' : "es",
    'Atlantic/Canary' : "es",
    'Europe/Helsinki' : "fi",
    'Pacific/Fiji' : "fj",
    'Atlantic/Stanley' : "fk",
    'Pacific/Chuuk' : "fm",
    'Pacific/Pohnpei' : "fm",
    'Pacific/Kosrae' : "fm",
    'Atlantic/Faroe' : "fo",
    'Europe/Paris' : "fr",
    'Europe/London' : "gb",
    'Asia/Tbilisi' : "ge",
    'America/Cayenne' : "gf",
    'Africa/Accra' : "gh",
    'Europe/Gibraltar' : "gi",
    // 'America/Godthab' : "as",
    'America/Danmarkshavn' : "gl",
    'America/Scoresbysund' : "gl",
    'America/Thule' : "gl",
    'Europe/Athens' : "gr",
    'Atlantic/South_Georgia' : "gs",
    'America/Guatemala' : "gt",
    'Pacific/Guam' : "gu",
    'Africa/Bissau' : "gw",
    'America/Guyana' : "gy",
    'Asia/Hong_Kong' : "hk",
    'America/Tegucigalpa' : "hn",
    'America/Port-au-Prince' : "ht",
    'Europe/Budapest' : "hu",
    'Asia/Jakarta' : "id",
    'Asia/Pontianak' : "id",
    'Asia/Makassar' : "id",
    'Asia/Jayapura' : "id",
    'Europe/Dublin' : "ie",
    'Asia/Jerusalem' : "il",
    'Asia/Kolkata' : "in",
    'Asia/Calcutta' : "in",
    'Indian/Chagos' : "io",
    'Asia/Baghdad' : "iq",
    'Asia/Tehran' : "ir",
    'Atlantic/Reykjavik' : "is",
    'Europe/Rome' : "it",
    'America/Jamaica' : "jm",
    'Asia/Amman' : "jo",
    'Asia/Tokyo' : "jp",
    'Africa/Nairobi' : "ke",
    'Asia/Bishkek' : "kg",
    'Pacific/Tarawa' : "ki",
    'Pacific/Enderbury' : "as",
    'Pacific/Kiritimati' : "ki",
    'Asia/Pyongyang' : "kp",
    'Asia/Seoul' : "kr",
    'Asia/Almaty' : "kz",
    'Asia/Qyzylorda' : "kz",
    'Asia/Qostanay' : "kz",
    'Asia/Aqtobe' : "kz",
    'Asia/Aqtau' : "kz",
    'Asia/Atyrau' : "kz",
    'Asia/Oral' : "kz",
    'Asia/Beirut' : "lb",
    'Asia/Colombo' : "lk",
    'Africa/Monrovia' : "lr",
    'Europe/Vilnius' : "lt",
    'Europe/Luxembourg' : "lu",
    'Europe/Riga' : "lv",
    'Africa/Tripoli' : "ly",
    'Africa/Casablanca' : "ma",
    'Europe/Monaco' : "mc",
    'Europe/Chisinau' : "md",
    'Pacific/Majuro' : "mh",
    'Pacific/Kwajalein' : "mh",
    'Asia/Yangon' : "mm",
    'Asia/Ulaanbaatar' : "mn",
    'Asia/Hovd' : "mn",
    'Asia/Choibalsan' : "mn",
    'Asia/Macau' : "mo",
    'America/Martinique' : "mq",
    'Europe/Malta' : "mt",
    'Indian/Mauritius' : "mu",
    'Indian/Maldives' : "mv",
    'America/Mexico_City' : "mx",
    'America/Cancun' : "mx",
    'America/Merida' : "mx",
    'America/Monterrey' : "mx",
    'America/Matamoros' : "mx",
    'America/Mazatlan' : "mx",
    'America/Chihuahua' : "mx",
    'America/Ojinaga' : "mx",
    'America/Hermosillo' : "mx",
    'America/Tijuana' : "mx",
    'America/Bahia_Banderas' : "mx",
    'Asia/Kuala_Lumpur' : "my",
    'Asia/Kuching' : "my",
    'Africa/Maputo' : "mz",
    'Africa/Windhoek' : "na",
    'Pacific/Noumea' : "nc",
    'Pacific/Norfolk' : "nf",
    'Africa/Lagos' : "ng",
    'America/Managua' : "ni",
    'Europe/Amsterdam' : "nl",
    'Europe/Oslo' : "no",
    'Asia/Kathmandu' : "np",
    'Pacific/Nauru' : "nr",
    'Pacific/Niue' : "nu",
    'Pacific/Auckland' : "nz",
    'Pacific/Chatham' : "nz",
    'America/Panama' : "pa",
    'America/Lima' : "pe",
    'Pacific/Tahiti' : "pf",
    'Pacific/Marquesas' : "pf",
    'Pacific/Gambier' : "pf",
    'Pacific/Port_Moresby' : "pg",
    'Pacific/Bougainville' : "pg",
    'Asia/Manila' : "ph",
    'Asia/Karachi' : "pk",
    'Europe/Warsaw' : "pl",
    'America/Miquelon' : "pm",
    'Pacific/Pitcairn' : "pn",
    'America/Puerto_Rico' : "pr",
    'Asia/Gaza' : "ps",
    'Asia/Hebron' : "ps",
    'Europe/Lisbon' : "pt",
    'Atlantic/Madeira' : "pt",
    'Atlantic/Azores' : "pt",
    'Pacific/Palau' : "pw",
    'America/Asuncion' : "py",
    'Asia/Qatar' : "qa",
    'Indian/Reunion' : "re",
    'Europe/Bucharest' : "ro",
    'Europe/Belgrade' : "rs",
    'Europe/Kaliningrad' : "ru",
    'Europe/Moscow' : "ru",
    'Europe/Simferopol' : "ua",
    'Europe/Kirov' : "ru",
    'Europe/Astrakhan' : "ru",
    'Europe/Volgograd' : "ru",
    'Europe/Saratov' : "ru",
    'Europe/Ulyanovsk' : "ru",
    'Europe/Samara' : "ru",
    'Asia/Yekaterinburg' : "ru",
    'Asia/Omsk' : "ru",
    'Asia/Novosibirsk' : "ru",
    'Asia/Barnaul' : "ru",
    'Asia/Tomsk' : "ru",
    'Asia/Novokuznetsk' : "ru",
    'Asia/Krasnoyarsk' : "ru",
    'Asia/Irkutsk' : "ru",
    'Asia/Chita' : "ru",
    'Asia/Yakutsk' : "ru",
    'Asia/Khandyga' : "ru",
    'Asia/Vladivostok' : "ru",
    'Asia/Ust-Nera' : "ru",
    'Asia/Magadan' : "ru",
    'Asia/Sakhalin' : "ru",
    'Asia/Srednekolymsk' : "ru",
    'Asia/Kamchatka' : "ru",
    'Asia/Anadyr' : "ru",
    'Asia/Riyadh' : "sa",
    'Pacific/Guadalcanal' : "sb",
    'Indian/Mahe' : "sc",
    'Africa/Khartoum' : "sd",
    'Europe/Stockholm' : "se",
    'Asia/Singapore' : "sg",
    'America/Paramaribo' : "sr",
    'Africa/Juba' : "ss",
    'Africa/Sao_Tome' : "st",
    'America/El_Salvador' : "sv",
    'Asia/Damascus' : "sy",
    'America/Grand_Turk' : "tc",
    'Africa/Ndjamena' : "td",
    'Indian/Kerguelen' : "tf",
    'Asia/Bangkok' : "th",
    'Asia/Dushanbe' : "tj",
    'Pacific/Fakaofo' : "tk",
    'Asia/Dili' : "tl",
    'Asia/Ashgabat' : "tm",
    'Africa/Tunis' : "tn",
    'Pacific/Tongatapu' : "to",
    'Europe/Istanbul' : "tr",
    'America/Port_of_Spain' : "tt",
    'Pacific/Funafuti' : "tv",
    'Asia/Taipei' : "tw",
    // 'Europe/Kiev' : "as",
    // 'Europe/Uzhgorod' : "as",
    // 'Europe/Zaporozhye' : "as",
    'Pacific/Wake' : "um",
    'America/New_York' : "us",
    'America/Detroit' : "us",
    'America/Kentucky/Louisville' : "us",
    'America/Kentucky/Monticello' : "us",
    'America/Indiana/Indianapolis' : "as",
    'America/Indiana/Vincennes' : "us",
    'America/Indiana/Winamac' : "us",
    'America/Indiana/Marengo' : "us",
    'America/Indiana/Petersburg' : "us",
    'America/Indiana/Vevay' : "us",
    'America/Chicago' : "us",
    'America/Indiana/Tell_City' : "us",
    'America/Indiana/Knox' : "us",
    'America/Menominee' : "us",
    'America/North_Dakota/Center' : "us",
    'America/North_Dakota/New_Salem' : "us",
    'America/North_Dakota/Beulah' : "us",
    'America/Denver' : "us",
    'America/Boise' : "us",
    'America/Phoenix' : "us",
    'America/Los_Angeles' : "us",
    'America/Anchorage' : "us",
    'America/Juneau' : "us",
    'America/Sitka' : "us",
    'America/Metlakatla' : "us",
    'America/Yakutat' : "us",
    'America/Nome' : "us",
    'America/Adak' : "us",
    'Pacific/Honolulu' : "us",
    'America/Montevideo' : "uy",
    'Asia/Samarkand' : "uz",
    'Asia/Tashkent' : "uz",
    'America/Caracas' : "ve",
    'Asia/Ho_Chi_Minh' : "vn",
    'Pacific/Efate' : "vu",
    'Pacific/Wallis' : "wf",
    'Pacific/Apia' : "ws",
    'Africa/Johannesburg': "za",
}

export const countryPhoneDigits = [
    { country: 'Afghanistan', code: '93', digits: 9 },
    { country: 'Albania', code: '355', digits: 8 },
    { country: 'Algeria', code: '213', digits: 9 },
    { country: 'Andorra', code: '376', digits: 6 },
    { country: 'Angola', code: '244', digits: 9 },
    { country: 'Argentina', code: '54', digits: 10 },
    { country: 'Armenia', code: '374', digits: 8 },
    { country: 'Australia', code: '61', digits: 9 },
    { country: 'Austria', code: '43', digits: 10 },
    { country: 'Azerbaijan', code: '994', digits: 9 },
    { country: 'Bahamas', code: '1-242', digits: 7 },
    { country: 'Bahrain', code: '973', digits: 8 },
    { country: 'Bangladesh', code: '880', digits: 10 },
    { country: 'Barbados', code: '1-246', digits: 7 },
    { country: 'Belarus', code: '375', digits: 9 },
    { country: 'Belgium', code: '32', digits: 8 },
    { country: 'Belize', code: '501', digits: 7 },
    { country: 'Benin', code: '229', digits: 8 },
    { country: 'Bhutan', code: '975', digits: 8 },
    { country: 'Bolivia', code: '591', digits: 8 },
    { country: 'Bosnia and Herzegovina', code: '387', digits: 8 },
    { country: 'Botswana', code: '267', digits: 7 },
    { country: 'Brazil', code: '55', digits: 11 },
    { country: 'Brunei', code: '673', digits: 7 },
    { country: 'Bulgaria', code: '359', digits: 8 },
    { country: 'Burkina Faso', code: '226', digits: 8 },
    { country: 'Burundi', code: '257', digits: 8 },
    { country: 'Cabo Verde', code: '238', digits: 7 },
    { country: 'Cambodia', code: '855', digits: 8 },
    { country: 'Cameroon', code: '237', digits: 9 },
    { country: 'Canada', code: '1', digits: 10 },
    { country: 'Central African Republic', code: '236', digits: 8 },
    { country: 'Chad', code: '235', digits: 8 },
    { country: 'Chile', code: '56', digits: 9 },
    { country: 'China', code: '86', digits: 11 },
    { country: 'Colombia', code: '57', digits: 10 },
    { country: 'Comoros', code: '269', digits: 7 },
    { country: 'Congo (Congo-Brazzaville)', code: '242', digits: 9 },
    { country: 'Congo (Democratic Republic of the)', code: '243', digits: 9 },
    { country: 'Costa Rica', code: '506', digits: 8 },
    { country: 'Croatia', code: '385', digits: 9 },
    { country: 'Cyprus', code: '357', digits: 8 },
    { country: 'Czech Republic', code: '420', digits: 9 },
    { country: 'Denmark', code: '45', digits: 8 },
    { country: 'Djibouti', code: '253', digits: 6 },
    { country: 'Dominica', code: '1-767', digits: 7 },
    { country: 'Dominican Republic', code: '1-809', digits: 10 },
    { country: 'Ecuador', code: '593', digits: 9 },
    { country: 'Egypt', code: '20', digits: 10 },
    { country: 'El Salvador', code: '503', digits: 8 },
    { country: 'Equatorial Guinea', code: '240', digits: 9 },
    { country: 'Eritrea', code: '291', digits: 7 },
    { country: 'Estonia', code: '372', digits: 7 },
    { country: 'Eswatini', code: '268', digits: 8 },
    { country: 'Ethiopia', code: '251', digits: 9 },
    { country: 'Fiji', code: '679', digits: 7 },
    { country: 'Finland', code: '358', digits: 9 },
    { country: 'France', code: '33', digits: 9 },
    { country: 'Gabon', code: '241', digits: 7 },
    { country: 'Gambia', code: '220', digits: 7 },
    { country: 'Georgia', code: '995', digits: 9 },
    { country: 'Germany', code: '49', digits: 10 },
    { country: 'Ghana', code: '233', digits: 9 },
    { country: 'Greece', code: '30', digits: 10 },
    { country: 'Grenada', code: '1-473', digits: 7 },
    { country: 'Guatemala', code: '502', digits: 8 },
    { country: 'Guinea', code: '224', digits: 9 },
    { country: 'Guinea-Bissau', code: '245', digits: 7 },
    { country: 'Guyana', code: '592', digits: 7 },
    { country: 'Haiti', code: '509', digits: 8 },
    { country: 'Honduras', code: '504', digits: 8 },
    { country: 'Hungary', code: '36', digits: 9 },
    { country: 'Iceland', code: '354', digits: 7 },
    { country: 'India', code: '91', digits: 10 },
    { country: 'Indonesia', code: '62', digits: 10 },
    { country: 'Iran', code: '98', digits: 10 },
    { country: 'Iraq', code: '964', digits: 10 },
    { country: 'Ireland', code: '353', digits: 9 },
    { country: 'Israel', code: '972', digits: 9 },
    { country: 'Italy', code: '39', digits: 10 },
    { country: 'Jamaica', code: '1-876', digits: 7 },
    { country: 'Japan', code: '81', digits: 10 },
    { country: 'Jordan', code: '962', digits: 9 },
    { country: 'Kazakhstan', code: '7', digits: 10 },
    { country: 'Kenya', code: '254', digits: 10 },
    { country: 'Kiribati', code: '686', digits: 7 },
    { country: 'Kuwait', code: '965', digits: 8 },
    { country: 'Kyrgyzstan', code: '996', digits: 9 },
    { country: 'Laos', code: '856', digits: 8 },
    { country: 'Latvia', code: '371', digits: 8 },
    { country: 'Lebanon', code: '961', digits: 8 },
    { country: 'Lesotho', code: '266', digits: 8 },
    { country: 'Liberia', code: '231', digits: 7 },
    { country: 'Libya', code: '218', digits: 9 },
    { country: 'Liechtenstein', code: '423', digits: 7 },
    { country: 'Lithuania', code: '370', digits: 8 },
    { country: 'Luxembourg', code: '352', digits: 6 },
    { country: 'Madagascar', code: '261', digits: 9 },
    { country: 'Malawi', code: '265', digits: 9 },
    { country: 'Malaysia', code: '60', digits: 10 },
    { country: 'Maldives', code: '960', digits: 7 },
    { country: 'Mali', code: '223', digits: 8 },
    { country: 'Malta', code: '356', digits: 8 },
    { country: 'Marshall Islands', code: '692', digits: 7 },
    { country: 'Mauritania', code: '222', digits: 8 },
    { country: 'Mauritius', code: '230', digits: 7 },
    { country: 'Mexico', code: '52', digits: 10 },
    { country: 'Micronesia', code: '691', digits: 7 },
    { country: 'Moldova', code: '373', digits: 8 },
    { country: 'Monaco', code: '377', digits: 7 },
    { country: 'Mongolia', code: '976', digits: 8 },
    { country: 'Montenegro', code: '382', digits: 8 },
    { country: 'Morocco', code: '212', digits: 9 },
    { country: 'Mozambique', code: '258', digits: 9 },
    { country: 'Myanmar (Burma)', code: '95', digits: 9 },
    { country: 'Namibia', code: '264', digits: 9 },
    { country: 'Nauru', code: '674', digits: 7 },
    { country: 'Nepal', code: '977', digits: 10 },
    { country: 'Netherlands', code: '31', digits: 9 },
    { country: 'New Zealand', code: '64', digits: 9 },
    { country: 'Nicaragua', code: '505', digits: 8 },
    { country: 'Niger', code: '227', digits: 8 },
    { country: 'Nigeria', code: '234', digits: 10 },
    { country: 'North Macedonia', code: '389', digits: 8 },
    { country: 'Norway', code: '47', digits: 8 },
    { country: 'Oman', code: '968', digits: 8 },
    { country: 'Pakistan', code: '92', digits: 10 },
    { country: 'Palau', code: '680', digits: 7 },
    { country: 'Palestine', code: '970', digits: 9 },
    { country: 'Panama', code: '507', digits: 7 },
    { country: 'Papua New Guinea', code: '675', digits: 9 },
    { country: 'Paraguay', code: '595', digits: 9 },
    { country: 'Peru', code: '51', digits: 9 },
    { country: 'Philippines', code: '63', digits: 10 },
    { country: 'Poland', code: '48', digits: 9 },
    { country: 'Portugal', code: '351', digits: 9 },
    { country: 'Qatar', code: '974', digits: 8 },
    { country: 'Romania', code: '40', digits: 10 },
    { country: 'Russia', code: '7', digits: 10 },
    { country: 'Rwanda', code: '250', digits: 10 },
    { country: 'Saint Kitts and Nevis', code: '1-869', digits: 7 },
    { country: 'Saint Lucia', code: '1-758', digits: 7 },
    { country: 'Saint Vincent and the Grenadines', code: '1-784', digits: 7 },
    { country: 'Samoa', code: '685', digits: 7 },
    { country: 'San Marino', code: '378', digits: 7 },
    { country: 'Sao Tome and Principe', code: '239', digits: 7 },
    { country: 'Saudi Arabia', code: '966', digits: 9 },
    { country: 'Senegal', code: '221', digits: 9 },
    { country: 'Serbia', code: '381', digits: 9 },
    { country: 'Seychelles', code: '248', digits: 7 },
    { country: 'Sierra Leone', code: '232', digits: 8 },
    { country: 'Singapore', code: '65', digits: 8 },
    { country: 'Slovakia', code: '421', digits: 9 },
    { country: 'Slovenia', code: '386', digits: 8 },
    { country: 'Solomon Islands', code: '677', digits: 7 },
    { country: 'Somalia', code: '252', digits: 8 },
    { country: 'South Africa', code: '27', digits: 9 },
    { country: 'South Korea', code: '82', digits: 10 },
    { country: 'South Sudan', code: '211', digits: 9 },
    { country: 'Spain', code: '34', digits: 9 },
    { country: 'Sri Lanka', code: '94', digits: 10 },
    { country: 'Sudan', code: '249', digits: 9 },
    { country: 'Suriname', code: '597', digits: 7 },
    { country: 'Sweden', code: '46', digits: 9 },
    { country: 'Switzerland', code: '41', digits: 9 },
    { country: 'Syria', code: '963', digits: 9 },
    { country: 'Taiwan', code: '886', digits: 9 },
    { country: 'Tajikistan', code: '992', digits: 9 },
    { country: 'Tanzania', code: '255', digits: 10 },
    { country: 'Thailand', code: '66', digits: 9 },
    { country: 'Togo', code: '228', digits: 8 },
    { country: 'Tonga', code: '676', digits: 7 },
    { country: 'Trinidad and Tobago', code: '1-868', digits: 7 },
    { country: 'Tunisia', code: '216', digits: 8 },
    { country: 'Turkey', code: '90', digits: 10 },
    { country: 'Turkmenistan', code: '993', digits: 9 },
    { country: 'Tuvalu', code: '688', digits: 7 },
    { country: 'Uganda', code: '256', digits: 10 },
    { country: 'Ukraine', code: '380', digits: 9 },
    { country: 'United Arab Emirates', code: '971', digits: 9 },
    { country: 'United Kingdom', code: '44', digits: 10 },
    { country: 'United States', code: '1', digits: 10 },
    { country: 'Uruguay', code: '598', digits: 8 },
    { country: 'Uzbekistan', code: '998', digits: 9 },
    { country: 'Vanuatu', code: '678', digits: 7 },
    { country: 'Vatican City', code: '379', digits: 7 },
    { country: 'Venezuela', code: '58', digits: 10 },
    { country: 'Vietnam', code: '84', digits: 9 },
    { country: 'Yemen', code: '967', digits: 9 },
    { country: 'Zambia', code: '260', digits: 10 },
    { country: 'Zimbabwe', code: '263', digits: 9 },
    { country: 'Hong Kong', code: '852', digits: 8 },
];  

export const parseIfJson=(str)=> {
    if (typeof str !== 'string') {
        return str;
    }
    try {
        const parsed = JSON.parse(str);
        if (typeof parsed === "object" && parsed !== null) {
            return parsed;
        }
    } catch (e) {
        // console.error(e, "error parseIfJson")
    }
    return str;
}

export const stopSpeaking = () =>{
    window?.speechSynthesis?.cancel(); 
}